import { Injectable } from '@angular/core';

import { CatalogObject } from '../catalog-object';
import { Adapter } from './adapter';

interface AdaptedDates {
    createdAt: Date;
    updatedAt: Date;
}

@Injectable({
    providedIn: 'root',
})
export class CatalogObjectAdapterService implements Adapter<CatalogObject> {
    adapt(item: any): CatalogObject {
        const adaptedDates: AdaptedDates = {
            createdAt: new Date(item?.createdAt),
            updatedAt: new Date(item?.updatedAt),
        };
        const adaptedCatalogObject: CatalogObject = { ...item, ...adaptedDates };

        return adaptedCatalogObject;
    }
}
